import { fromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
// Constants
import { SELECTED_FOLDERABLE_OPERATION_SLICE_KEY } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.reducer';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
// Directives
import { FolderableMoveModalDirective } from 'FoldersApp/features/folders-shared/folderable-move-modal/folderable-move-modal.directive';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i2 from "@angular/forms";
import * as i3 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i5 from "../../../../../sharing/static/sharing/ts/pipes/get-sharing-tooltip-message.pipe";
import * as i6 from "../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
const _forTrack0 = ($index, $item) => $item.id;
function FolderableMoveModalComponent_Conditional_0_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(3, "div", 5);
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵlistener("click", function FolderableMoveModalComponent_Conditional_0_Conditional_1_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 8)(7, "div", 9)(8, "div", 10)(9, "div", 11)(10, "div", 12);
    i0.ɵɵtext(11, "Loading Folders");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "div", 13);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(13, "div", 14)(14, "button", 15);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(15, "svg", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(16, "button", 17);
    i0.ɵɵtext(17, "Move Here");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-close");
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("name", "icon-folder-add");
} }
function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Conditional_7_For_2_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵpipe(1, "getSharingTooltipMessage");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const folder_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", i0.ɵɵpipeBind1(1, 4, folder_r5));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-team");
} }
function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Conditional_7_For_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("click", function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Conditional_7_For_2_Template_div_click_0_listener() { const folder_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.setModalViewRootFolder(folder_r5.id)); });
    i0.ɵɵelement(1, "span", 25);
    i0.ɵɵtemplate(2, FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Conditional_7_For_2_Conditional_2_Template, 3, 6, "div", 26);
    i0.ɵɵpipe(3, "isSharedWithOthers");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const folder_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabled", !ctx_r1.isValidTargetFolder(folder_r5));
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", folder_r5.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(3, 3, folder_r5) ? 2 : -1);
} }
function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵrepeaterCreate(1, FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Conditional_7_For_2_Template, 4, 5, "div", 23, _forTrack0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.folders);
} }
function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1, "There are no folders in this folder.");
    i0.ɵɵelementEnd();
} }
function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 18);
    i0.ɵɵlistener("click", function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.setModalViewRootFolder(ctx_r1.ancestorFolderId)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(3, "div", 19);
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵlistener("click", function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵtemplate(7, FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Conditional_7_Template, 3, 0, "div", 9)(8, FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Conditional_8_Template, 2, 0, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 14)(10, "button", 21);
    i0.ɵɵlistener("click", function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.toggleView()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(11, "svg", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(12, "button", 22);
    i0.ɵɵlistener("click", function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.move()); });
    i0.ɵɵtext(13, "Move Here");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.viewRootFolderName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-close");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.folders && ctx_r1.folders.length > 0 ? 7 : 8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("tooltipTitle", "Add a Folder")("disabled", ctx_r1.cannotCreateFolder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-folder-add");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.cannotMoveItem);
} }
function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 18);
    i0.ɵɵlistener("click", function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_1_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.toggleView()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 28)(4, "input", 29);
    i0.ɵɵtwoWayListener("ngModelChange", function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r1.newFolderName, $event) || (ctx_r1.newFolderName = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keydown.enter", function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_1_Template_input_keydown_enter_4_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.createFolder()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 30)(6, "button", 31);
    i0.ɵɵlistener("click", function FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_1_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.createFolder()); });
    i0.ɵɵtext(7, "OK");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(8, "div", 8);
    i0.ɵɵelement(9, "div", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 14)(11, "button", 33);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(13, "button", 17);
    i0.ɵɵtext(14, "Move Here");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.newFolderName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.newFolderName === "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", "Create a new folder in '" + ctx_r1.modalViewRootFolder.name + "'");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", "Add a Folder");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-folder-add");
} }
function FolderableMoveModalComponent_Conditional_0_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_0_Template, 14, 8)(1, FolderableMoveModalComponent_Conditional_0_Conditional_2_Conditional_1_Template, 15, 6);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.viewStyle === ctx_r1.MoveModalView.MOVE ? 0 : 1);
} }
function FolderableMoveModalComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FolderableMoveModalComponent_Conditional_0_Conditional_1_Template, 18, 3)(2, FolderableMoveModalComponent_Conditional_0_Conditional_2_Template, 2, 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("z-index", 2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.modalViewRootFolder === null ? 1 : 2);
} }
/**
 * Modal for moving a file or folder.
 * On initialization, the modal shows all folders in the moving item's parent folder.
 * If the moving item is an orphan, then all folders in My YCharts are shown.
 */
export class FolderableMoveModalComponent extends FolderableMoveModalDirective {
    constructor() {
        super(...arguments);
        this.item = null;
    }
    get cannotMoveItem() {
        const movingIntoCurrParent = this.item?.ancestorFolderId === this.modalViewRootFolder?.id;
        const cannotEditFolder = !this.modalViewRootFolder.permissions?.canEdit;
        const pendingMoveItemRequest = this.moveItemSubscription === null ? false : !this.moveItemSubscription.closed;
        return cannotEditFolder || movingIntoCurrParent || pendingMoveItemRequest;
    }
    ngOnInit() {
        this.store
            .select(SELECTED_FOLDERABLE_OPERATION_SLICE_KEY)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((selectedOperation) => {
            if (selectedOperation?.operation === 'move') {
                this.item = selectedOperation.item;
                this.open = true;
            }
            if (this.item !== null && this.item.relativePositionedElemId) {
                this.positionModal(this.item.relativePositionedElemId);
                this.setModalViewRootFolder(selectedOperation.item.ancestorFolderId);
            }
        });
        fromEvent(window, 'resize')
            .pipe(takeUntil(this.unsubscribe), debounceTime(50)) // Wait for relative positioned elem to be repainted
            .subscribe(() => {
            if (this.item !== null && this.item.relativePositionedElemId) {
                this.positionModal(this.item.relativePositionedElemId);
            }
        });
        // eslint-disable-next-line no-unused-expressions
        this.folderCollectionService.viewResponse$
            ?.pipe(takeUntil(this.unsubscribe), debounceTime(50)) // Wait for relative positioned elem to be repainted
            .subscribe(() => {
            if (this.item !== null && this.item.relativePositionedElemId) {
                this.positionModal(this.item.relativePositionedElemId);
            }
        });
    }
    positionModal(elemId) {
        const elem = document.getElementById(elemId);
        const bBox = elem.getBoundingClientRect();
        const parent = this.eltRef.nativeElement.offsetParent;
        const parentBBox = parent.getBoundingClientRect();
        this.eltRef.nativeElement.style.top = `${bBox.bottom - parentBBox.top + parent.scrollTop}px`;
        this.eltRef.nativeElement.style.left = `${bBox.left + bBox.width - parentBBox.left}px`;
        this.eltRef.nativeElement.style.position = 'absolute';
    }
    isValidTargetFolder(folder) {
        if (this.item === null)
            throw new Error('Cannot validate target folder without moving item.');
        if (this.item.itemType === FolderableType.FOLDER && this.item.id === folder.id)
            return false;
        return folder.permissions.canEdit;
    }
    move() {
        if (this.item === null || this.modalViewRootFolder === null)
            return;
        this.moveItemSubscription = this.folderOperationsService
            .moveFolderableItem(this.item.itemType, this.item?.id, this.modalViewRootFolder.id)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe({
            next: (response) => {
                this.closeModal();
                this.folderCollectionService.refreshData();
                this.toastMessagesService.addMessage(response.message);
            },
            error: (response) => {
                this.toastMessagesService.addMessage(response.error.error_message, ToastMessageType.ERROR);
            },
        });
    }
    closeModal() {
        super.closeModal();
        this.item = null;
    }
}
FolderableMoveModalComponent.ɵfac = /*@__PURE__*/ (() => { let ɵFolderableMoveModalComponent_BaseFactory; return function FolderableMoveModalComponent_Factory(__ngFactoryType__) { return (ɵFolderableMoveModalComponent_BaseFactory || (ɵFolderableMoveModalComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FolderableMoveModalComponent)))(__ngFactoryType__ || FolderableMoveModalComponent); }; })();
FolderableMoveModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableMoveModalComponent, selectors: [["ycn-folderable-move-modal"]], standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[1, "popover", "popover-large", "popover-over", "file-move-popover", "show", 3, "z-index"], [1, "popover", "popover-large", "popover-over", "file-move-popover", "show"], [1, "popover-header"], [1, "btn", "btn-xs", "btn-circle", "btn-text", "btn-back", "disabled"], ["role", "img", "ycnIcon", "", 1, "icon-back", 3, "name"], [1, "popover-title"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["role", "img", "ycnIcon", "", 1, "icon-close", 3, "name"], [1, "popover-body"], [1, "files-list"], [1, "file-name"], [1, "loader", "ml-4"], [1, "loader-message"], [1, "loader-spinner"], [1, "popover-footer"], [1, "btn", "btn-transparent2", "disabled"], ["role", "img", "ycnIcon", "", 1, "icon-folder-add", 3, "name"], [1, "btn", "btn-primary", "disabled"], [1, "btn", "btn-xs", "btn-circle", "btn-text", "btn-back", 3, "click"], [1, "popover-title", 3, "textContent"], [1, "files-empty-message"], ["ycnTooltip", "", "ycnDisabled", "", 1, "btn", "btn-transparent2", 3, "click", "tooltipTitle", "disabled"], ["ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled"], ["ycnDisabled", "", 1, "file-name", 3, "disabled"], ["ycnDisabled", "", 1, "file-name", 3, "click", "disabled"], [1, "file-title", 3, "textContent"], ["ycnTooltip", "", 1, "filepath-title", "btn", "btn-circle", "btn-share", "btn-transparent", "btn-xs", "ml-1", "btn-transparent3", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "input-group"], ["id", "folderNameInput", "type", "text", "placeholder", "Enter a name", 1, "form-control", 3, "ngModelChange", "keydown.enter", "ngModel"], [1, "input-group-btn"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], [1, "files-empty-message", 3, "textContent"], ["ycnTooltip", "", 1, "btn", "btn-transparent2", "disabled", 3, "tooltipTitle"]], template: function FolderableMoveModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FolderableMoveModalComponent_Conditional_0_Template, 3, 3, "div", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.open ? 0 : -1);
    } }, dependencies: [i1.DisabledDirective, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i3.IconDirective, i4.TooltipDirective, i5.GetSharingTooltipMessage, i6.IsSharedWithOthersPipe], encapsulation: 2 });
